export class UserPagePermissionModel {
  public pageId: number;
  public pageName: string;
  public permissionId: number;
  public permissionName: string;
  public pageUrl: string;
  public menuName: string;
  public menuId: string;
}


///** represent chat message class */
//export class ChatMessage {

//  user: string;
//  message: string;
//  room: string;

//  constructor(user: string = '', message: string = '', room: string = '') {
//    this.user = user;
//    this.message = message;
//    this.room = room;
//  }
//} 
